import * as React from "react";

import { FormFieldExtensionKeys_AddressAutocomplete } from "../../../Common/form/logic";

import { useDataMutableSourceShippingSessionStorageData_asController } from "../data-mutable-source-shipping-session-storage-data-provider";

import { useShippingForm } from "./use-shipping-form";

export const SendChangesToSession: React.FunctionComponent = (props) => {
  const { form: shippingForm } = useShippingForm();
  const {
    handleLastFormattedAutocompletedAddressChange_forShipping,
    handleLastFormattedAutocompletedAddressChange_forBilling,
  } = useDataMutableSourceShippingSessionStorageData_asController();

  const shippingAddressAutocompleteValue =
    shippingForm[`shipping_autocompleteAddress`];
  const shippingAddressSelectedFromAutocompleteValue =
    shippingForm[
      `shipping_autocompleteAddress${FormFieldExtensionKeys_AddressAutocomplete.SelectedFromAutocomplete}`
    ];

  const billingAddressAutocompleteValue =
    shippingForm[`billing_autocompleteAddress`];
  const billingAddressSelectedFromAutocompleteValue =
    shippingForm[
      `billing_autocompleteAddress${FormFieldExtensionKeys_AddressAutocomplete.SelectedFromAutocomplete}`
    ];

  React.useEffect(() => {
    if (shippingAddressSelectedFromAutocompleteValue) {
      handleLastFormattedAutocompletedAddressChange_forShipping(
        shippingAddressAutocompleteValue
      );
    }
  }, [
    shippingAddressAutocompleteValue,
    shippingAddressSelectedFromAutocompleteValue,
    handleLastFormattedAutocompletedAddressChange_forShipping,
  ]);

  React.useEffect(() => {
    if (billingAddressSelectedFromAutocompleteValue) {
      handleLastFormattedAutocompletedAddressChange_forBilling(
        billingAddressAutocompleteValue
      );
    }
  }, [
    billingAddressSelectedFromAutocompleteValue,
    billingAddressAutocompleteValue,
    handleLastFormattedAutocompletedAddressChange_forBilling,
  ]);

  return <React.Fragment>{props?.children || []}</React.Fragment>;
};
